import './smartSheet.css'
import { CloseButton, MainButton } from '../../components/atoms/button/Button';
import { QuizButton, QuizCompletionCard, QuizExplanation, QuizHeading, QuizQuestion, QuizReadOnlyButton } from '../../components/molecule/quizItems/QuizItems';
import { HeaderSM, MainHeader } from '../../components/atoms/header/Header';
import { Dispatch, useContext, useEffect, useState } from 'react';
import apis from '../../apis/api';
import { StatusCodes } from 'http-status-codes';
import AppLoader, { ConfettiAnimation } from '../../components/atoms/animation/Animation';
import { useSelector } from 'react-redux';
import { IReducer, ISmartSheetReducer } from '../../interface/interface';
import { useDispatch } from 'react-redux';
import { smartSheetActions } from '../../reduxStore';
import { AppContext } from '../../context/context';
import components from '../../assets/data/components.json'
import { CompleteQuizPopUp, StartQuizPopUp } from '../../components/molecule/popUp/AppPopUp';
import { getTimeSpent } from '../../utils/utils';

export default function SmartSheetPlay() {

    useEffect(() => {
        fetchSmartSheet();
    }, [])

    const dispatch: Dispatch<any> = useDispatch();
    const app: any = useContext(AppContext);
    const state: IReducer = useSelector((state: IReducer) => state);
    const smartSheet: ISmartSheetReducer = useSelector((state: IReducer) => state.smartSheetReducer);

    const [loader, setLoader] = useState(false);
    const [startTime, setStartTime]: any = useState(0);
    const [smartSheetTaken, setSmartSheetTaken]: any = useState({});// {isCompleted: 0, totalQuestion: 5, totalAttempted: 0}
    const [showStartPopUp, setShowStartPopUp] = useState(false);
    const [showEndPopUp, setShowEndPopUp] = useState(false);
    const [totalCoins, setTotalCoins] = useState(0);//coins collected for active smartSheet 
    const [totalCollectedCoins, setTotalCollectedCoins] = useState(0);//coins collected for active smartSheet 
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [isCompletedAnimation, setIsCompletedAnimation] = useState(false);
    const [isCorrectAnswer, setIsCorrectAnswer] = useState(false);
    const [isCorrectAnswerAnimation, setIsCorrectAnswerAnimation] = useState(false);
    const [attemptedFirstQuestion, setAttemptedFirstQuestion] = useState(false)
    const [playSmartSheet, setPlaySmartSheet]: any = useState({
        loName: '',
        question_list: [
            {
                solution: 1, difficulty_level: 1, data: {
                    question: '', _id: '', q_image: '',
                    options: [{ _id: '', explanation: '', value: '', option_id: 0 }]
                }
            }], smartSheet_name: ''
    });
    const [pickedChoicePos, setPickedChoicePos] = useState(-1);
    const [isCheckAnswer, setIsCheckAnswer] = useState(false);
    const [isSmartSheetCompleted, setIsSmartSheetCompleted] = useState(false);

    const clearState = () => {
        setPlaySmartSheet({});
        setIsSmartSheetCompleted(false);
        setPickedChoicePos(-1);
        setCurrentQuestion(0);
    }

    const fetchSmartSheet = async () => {
        setLoader(true);
        let country_code = state.userReducer.currentUser.isB2C ?
            state.userReducer.currentUser.country_code : state.userReducer.currentUser.classroom_country_code;
        country_code = country_code === "IN" ? "IN" : "US";

        if (smartSheet.smartSheetData && smartSheet.smartSheetData._id) {
            let smartSheetTakenRes = await apis._isSmartSheetTaken(
                { "smart_sheet_id": smartSheet.smartSheetData._id, "country_code": country_code });

            if (smartSheetTakenRes.status === StatusCodes.OK) {
                setSmartSheetTaken(smartSheetTakenRes.data.collection)
                if (smartSheetTakenRes.data.collection.isCompleted !== 0)
                    setShowStartPopUp(true);
            }

            let questionsRes = await apis._fetchSmartSheet(
                {
                    "smart_sheet_id": smartSheet.smartSheetData._id,
                    "lo_id": smartSheet.loId,
                    "country_code": country_code
                });

            if (questionsRes.status === StatusCodes.OK) {
                setPlaySmartSheet(questionsRes.data.collection);
            }
        }
        setLoader(false);
        setStartTime(new Date());
    }

    let onCheckAnswer = async () => {
        let pos = pickedChoicePos;
        if (pos === -1)
            return;
        let questionObj = playSmartSheet.question_list[currentQuestion];
        let optionChosen = questionObj.data.options[pos].option_id;
        let isCorrect = (optionChosen === questionObj.solution) ? true : false;
        let tCoins = totalCoins + questionObj.difficulty_level + 1;
        let collectedCoins = (isCorrect) ? totalCollectedCoins + questionObj.difficulty_level + 1 : totalCollectedCoins;

        setTotalCoins(tCoins);
        setTotalCollectedCoins(collectedCoins)
        setIsCorrectAnswer(isCorrect);
        setIsCheckAnswer(true);
        if (currentQuestion === 0) {
            setAttemptedFirstQuestion(true)
        }
        if (isCorrect) {
            setIsCorrectAnswerAnimation(true)
            setTimeout(() => {
                setIsCorrectAnswerAnimation(false)
            }, 3000);
        }

        if (smartSheetTaken.isCompleted !== 0)
            return;

        const currentUser = state.userReducer.currentUser;

        let result = {
            "smart_sheet_id": smartSheet.smartSheetData._id,
            "question_id": questionObj.data._id,
            "lo_id": smartSheet.loId,
            "option_chosen": optionChosen,
            "time_taken": getTimeSpent(startTime),
            "isCorrect": isCorrect,
            "isCompleted": (currentQuestion === playSmartSheet.question_list.length - 1) ? true : false,
            "organization": currentUser.organization,
            "grade": currentUser.role === 'teacher' ? 100 : currentUser.grade,
            "classroom_id": currentUser.isB2C ? undefined : currentUser.classroom_id,
        }

        let saveResult = await apis._saveSmartSheetResult(result);
        if (saveResult.status === StatusCodes.OK) {
            // Update Redux
            // Notify parent of result
            app.messageForParent('SMARTSHEET_ANSWER', {
                questionsAnswered: 1,
                coinsEarned: isCorrect ? (questionObj.difficulty_level + 1) : 0,
                time_taken: result.time_taken,
            });
        }
    }

    let nextQuestion = () => {
        let count = currentQuestion;
        count += 1;
        setPickedChoicePos(-1);
        setIsCheckAnswer(false);
        setCurrentQuestion(count);
        setStartTime(new Date());
    }
    const onSaveAndFinish = () => {
        setIsSmartSheetCompleted(true)
        setIsCompletedAnimation(true)
        setTimeout(() => {
            setIsCompletedAnimation(false);
        }, 3000)
    }
    const onClickClose = () => {
        if (smartSheetTaken.isCompleted !== 0 || (playSmartSheet.question_list && currentQuestion === playSmartSheet.question_list.length - 1 && isCheckAnswer))
            onClose()
        else
            setShowEndPopUp(true);
    }
    const onClose = () => {
        clearState();
        dispatch(smartSheetActions.setSmartSheetInfo({ loId: '', smartSheetData: {} }));
        dispatch(smartSheetActions.setIsSmartSheetLoaded(false));
        app.messageForParent('close');
    }


    return (<>
        {(loader) && (<AppLoader></AppLoader>)}
        {(!loader && !isSmartSheetCompleted && playSmartSheet.question_list) && (
            <div className='smartSheetPlayPopUp d-flex flex-column align-items-center justify-content-evenly'>
                {(showStartPopUp) && (
                    <StartQuizPopUp text={["You have already taken this smartsheet.", "Hence, this smartsheet will not be graded"]}
                        onStart={() => { setShowStartPopUp(false) }} onClose={onClose}></StartQuizPopUp>
                )}
                {(showEndPopUp) && (
                    <CompleteQuizPopUp
                        text={["You have not answered all the questions.", "Are you sure you want to exit?"]}
                        onCancel={() => { setShowEndPopUp(false) }}
                        onEnd={onClose}
                        options={attemptedFirstQuestion ? ['Cancel', 'Save & Finish'] : ['No', 'Yes']}></CompleteQuizPopUp>
                )}
                <CloseButton onClick={onClickClose} height="5vh" top='1%' right='1%'></CloseButton>
                <MainHeader text={playSmartSheet.smartSheet_name}></MainHeader>
                <QuizHeading currentQuestion={currentQuestion + 1} totalQuestion={playSmartSheet.question_list.length}
                    width={app.windowWidth <= 576 ? "80%" : "65%"} progressType={'2'}
                    coin={playSmartSheet.question_list[currentQuestion].difficulty_level + 1}></QuizHeading>
                <div className='smartSheetBody'>
                    <QuizQuestion text={playSmartSheet.question_list[currentQuestion].data.question}
                        q_image={playSmartSheet.question_list[currentQuestion].data.q_image} width='100%'></QuizQuestion>

                    {(!isCorrectAnswer && isCheckAnswer) && (
                        <QuizExplanation text={
                            playSmartSheet.question_list[currentQuestion].data.options[playSmartSheet.question_list[currentQuestion].solution - 1].explanation}
                            q_image={playSmartSheet.question_list[currentQuestion].data.options[playSmartSheet.question_list[currentQuestion].solution - 1].explanation_endpoint}></QuizExplanation>
                    )}
                    <div className='smartSheetChoiceContainer' style={{ minHeight: playSmartSheet.question_list[currentQuestion].data.options[0].image_endpoint ? '50vh' : '30vh' }}>
                        {(playSmartSheet.question_list[currentQuestion].data.options.map((opObj: { _id: string, image_endpoint: string, value: string, option_id: number }, ii: number) => {
                            if (!isCheckAnswer)
                                return (
                                    <QuizButton key={ii} text={opObj.value} variant={1}
                                        width={app.windowWidth <= 576 ? "98%" : "47%"}
                                        height={app.windowWidth <= 576 ? `${95 / playSmartSheet.question_list[currentQuestion].data.options.length}%` : '47%'}
                                        active={pickedChoicePos == ii}
                                        image={opObj.image_endpoint}
                                        onClick={() => { setPickedChoicePos(ii) }}></QuizButton>
                                )
                            else
                                return (
                                    <QuizReadOnlyButton key={ii} text={opObj.value}
                                        image={opObj.image_endpoint}
                                        width={app.windowWidth <= 576 ? "98%" : "47%"}
                                        height={app.windowWidth <= 576 ? `${95 / playSmartSheet.question_list[currentQuestion].data.options.length}%` : '47%'}
                                        variant={(opObj.option_id == playSmartSheet.question_list[currentQuestion].solution) ? 2 :
                                            (opObj.option_id == pickedChoicePos + 1) ? 3 : 1}
                                        onClick={() => { }}></QuizReadOnlyButton>
                                )
                        }))}
                    </div>

                    <div className='smartSheetButtonContainer'>
                        {(isCorrectAnswerAnimation) && (
                            <div className='correctAnswerAnimation'><img src={components.baseURL + `correct_animation.gif?${new Date().toISOString()}`}></img></div>
                        )}
                        {(!isCheckAnswer) && (
                            <MainButton text='Check' width='50%' height='100%' variant={6} disabled={pickedChoicePos === -1 ? true : false} onClick={onCheckAnswer} ></MainButton>
                        )}
                        {(isCheckAnswer && currentQuestion < playSmartSheet.question_list.length - 1) && (
                            <MainButton text='Next' width='50%' height='100%' variant={6} onClick={nextQuestion}></MainButton>
                        )}
                        {(isCheckAnswer && currentQuestion === playSmartSheet.question_list.length - 1) && (
                            <MainButton text='Save & Finish' width='50%' height='100%' variant={6} onClick={onSaveAndFinish}></MainButton>
                        )}
                    </div>
                </div>
            </div>)}

        {(isSmartSheetCompleted) && (
            <div className='smartSheetPlayPopUp d-flex flex-column align-items-center justify-content-start'>
                <CloseButton onClick={onClose} height="5vh" top='1%' right='1%'></CloseButton>
                <div className='smartSheetBody' style={{ paddingTop: '30px' }}>
                    <QuizCompletionCard
                        head={(smartSheetTaken.isCompleted !== 0) ? "Hurray!" : "Great!"}
                        text={(smartSheetTaken.isCompleted === 0) ? 'You have completed SmartSheet' : 'Hope you enjoyed your practice!'}
                        width={app.windowWidth <= 576 ? "95%" : "70%"} height='40%'></QuizCompletionCard>
                    <HeaderSM text={"Percentage: " + Math.round((Number(totalCollectedCoins) / Number(totalCoins)) * 100) + "%"} ></HeaderSM>
                    {(smartSheetTaken.isCompleted === 0) && (
                        <HeaderSM text={"Coins collected: " + totalCollectedCoins} ></HeaderSM>
                    )}
                </div>
                {(isCompletedAnimation) && (
                    <ConfettiAnimation></ConfettiAnimation>
                )}
            </div>)}

    </>)
}
